import { render, staticRenderFns } from "./booking-create-stepper-v2.vue?vue&type=template&id=2aa14ffe&scoped=true&"
import script from "./booking-create-stepper-v2.vue?vue&type=script&lang=js&"
export * from "./booking-create-stepper-v2.vue?vue&type=script&lang=js&"
import style0 from "./booking-create-stepper-v2.vue?vue&type=style&index=0&id=2aa14ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa14ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperHeader,VStepperStep})
